export default function ContactDetails() {
    return (
        <>
            <section id="contact-information-section">
                <div className="contact-info-container">
                    <div className="contact-information-header">
                        <h2 className="section-title">CONTACT INFORMATION</h2>
                        <p className="section-subtitle">Multiple ways to reach us for your musical journey</p>
                    </div>

                    <div className="contact-information-cards">
                        <div className="contact-information-card">
                            <div className="contact-information-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                                </svg>
                            </div>
                            <h3 className="contact-information-card-title">Phone Numbers</h3>
                            <div className="contact-information-content">
                                <div className="contact-information-item">
                                    <span className="contact-information-label">PRIMARY:</span>
                                    <span className="contact-information-value"><a href="tel:+91-8769373591">+91-8769373591</a></span>
                                </div>
                                <div className="contact-information-item">
                                    <span className="contact-information-label">SECONDARY:</span>
                                    <span className="contact-information-value"><a href="tel:+91-8769073591">+91-8769073591</a></span>
                                </div>
                            </div>
                        </div>

                        <div className="contact-information-card">
                            <div className="contact-information-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                    <polyline points="22,6 12,13 2,6" />
                                </svg>
                            </div>
                            <h3 className="contact-information-card-title">Email Addresses</h3>
                            <div className="contact-information-content">
                                <div className="contact-information-item">
                                    <span className="contact-information-label">GENERAL:</span>
                                    <span className="contact-information-value"><a href="mailto:harshitaschoolofmusic@gmail.com">harshitaschoolofmusic@gmail.com</a></span>
                                </div>
                                <div className="contact-information-item">
                                    <span className="contact-information-label">FOUNDER:</span>
                                    <span className="contact-information-value"><a href="mailto:harshitarewadia@gmail.com">harshitarewadia@gmail.com</a></span>
                                </div>
                            </div>
                        </div>

                        <div className="contact-information-card">
                            <div className="contact-information-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12,6 12,12 16,14" />
                                </svg>
                            </div>
                            <h3 className="contact-information-card-title">Business Hours</h3>
                            <div className="contact-information-content">
                                <div className="contact-information-item">
                                    <span className="contact-information-label">MONDAY - FRIDAY:</span>
                                    <span className="contact-information-value">8:00 AM - 8:00 PM IST</span>
                                </div>
                                <div className="contact-information-item">
                                    <span className="contact-information-label">SATURDAY:</span>
                                    <span className="contact-information-value">10:00 AM - 7:00 PM IST</span>
                                </div>
                                <div className="contact-information-item">
                                    <span className="contact-information-label">SUNDAY:</span>
                                    <span className="contact-information-value">12:00 PM - 5:00 PM IST</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
} 